import { toast } from "sonner";
import api from "@/lib/api";

let jobs = [];
const subs = new Set();
const polling = new Set();
const emit = () => subs.forEach((f) => f(jobs));
const upsert = (j) => {
  if (jobs.some((x) => x.id === j.id)) { jobs = jobs.map((x) => (x.id === j.id ? j : x)); emit(); return; }
  const next = [j, ...jobs];
  while (next.length > 4) {
    const i = next.map((x) => x.status !== "running").lastIndexOf(true);
    next.splice(i > 0 ? i : next.length - 1, 1);
  }
  jobs = next; emit();
};

export const subscribeJobs = (fn) => { subs.add(fn); fn(jobs); return () => subs.delete(fn); };
export const dismissJob = (id) => { jobs = jobs.filter((x) => x.id !== id); emit(); };

const wait = (ms) => new Promise((r) => setTimeout(r, ms));

const saveFile = async (job) => {
  const r = await api.get(`/jobs/${job.id}/download`, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data); a.download = job.filename; a.click(); URL.revokeObjectURL(a.href);
};

async function track(job, { onProgress, silent } = {}) {
  polling.add(job.id);
  if (!silent) upsert(job);
  while (job.status === "running") {
    await wait(1000);
    try { job = (await api.get(`/jobs/${job.id}`)).data; } catch (e) {
      if (e.response && e.response.status < 500) { job = { ...job, status: "failed", error: "Lost track of this job" }; } else continue;
    }
    if (!silent) upsert(job);
    onProgress?.(job);
  }
  polling.delete(job.id);
  setTimeout(() => dismissJob(job.id), 5000);
  if (job.status === "failed") { toast.error(job.error || "Background job failed"); const err = new Error(job.error); err.toasted = true; throw err; }
  if (job.file_path) {
    try { await saveFile(job); } catch { toast.error("Download failed — use the Job tray to retry"); }
  }
  return job.result ?? job;
}

// Starts a background job (start() must resolve to the API's {job_id} response) and tracks it in the Job tray.
export async function runJob(start, opts) {
  let res;
  try { res = await start(); } catch (e) { toast.error(e.response?.data?.detail || "Could not start"); e.toasted = true; throw e; }
  return track({ ...res, id: res.job_id }, opts);
}

// Re-attach to jobs still running after a page refresh.
export async function resumeJobs() {
  try {
    const { data } = await api.get("/jobs");
    data.filter((j) => j.status === "running" && !polling.has(j.id))
      .forEach((j) => track(j).catch(() => {}));
  } catch { /* not signed in */ }
}

export const retryDownload = (job) => saveFile(job).catch(() => toast.error("Download failed"));
